"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _useScheduleTimeZone = require('shared/hooks/scheduledMessages/useScheduleTimeZone');

// Web and desktop remember the zone in this browser profile. Reading
// localStorage itself can throw (blocked site data); the zone is then the
// browser's.
const storage = {
  getItem: (key) => window.localStorage.getItem(key),
  setItem: (key, value) => window.localStorage.setItem(key, value),
}

 const useScheduleTimeZone = () => _useScheduleTimeZone.useScheduleTimeZone.call(void 0, storage); exports.useScheduleTimeZone = useScheduleTimeZone
